import React from 'react';
import * as ProductTileGoogleAnalytics from '../../_modules/google_analytics/product/product_tiles';
import { CatalogAdsStore } from '../../_flux/stores/catalog_ads_store';
import { setSkuAction, showAction } from '../../_flux/actions/notify_me_actions';
import { CatalogAds } from '../../_flux/components/catalog_ads/catalog_ads';
import { handleView } from '../handle_view';
import { show } from '../../_flux/actions/friendbuy_light_box_actions';
import { setAction as setProductAction } from '../../_flux/actions/products_actions';
import LightboxActions, { openAction as openCarFittingStationFinder } from '../../_flux/actions/lightbox_actions';
import MapActions from '../../_flux/actions/map_actions';
import { ProductsStore } from '../../_flux/stores/products_store';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import { getMap } from '../../_flux/helper/gmap';
import parseGoogleLatLng from '../../_flux/helper/parse_google_lat_lng';
import FittingStationStore from '../../_flux/stores/fitting_station_store';
import StationsActions from '../../_flux/actions/fitting_station_actions';
import MapStore from '../../_flux/stores/map_store';
import PostcodeStore from '../../_flux/stores/postcode_store';
import { loadStations } from '../../_modules/fitting_station/load_stations';
import { FsfPages } from '../../_constants/fsf_pages';
import openAlternativeProductStockOnClick from '../catalog_items/open_alternative_product_stock_onlick';
import { loadGoogleMapDependencies } from '../../_global/initGoogleMapDependencies';

const stores = {
    state: CatalogAdsStore,
};

const render = ({ state }, options) => (
    <CatalogAds
        ads={state.ads}
        onNotifyMeClick={onNotifyMeClick}
        onOpenFSFClick={onOpenFSFClick}
        staticImagesUrl={TYROOLA.globals.staticImagesUrl}
        metroArea={options.metroArea}
        showShowDetailsButton={options.showShowDetailsButton}
        onProductClick={onProductClick}
        currencyIsoCode={TYROOLA.globals.currencyIsoCode}
        onSeeHowItWorksClick={e => e.preventDefault() ^ show()}
        productType={options.productType}
        onAlternativeProductStockClick={onAlternativeProductStockClick}
        buyerAssistUrl={state.buyerAssistUrl}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);

const onNotifyMeClick = productSku => {
    setSkuAction(productSku);
    showAction();
    ProductTileGoogleAnalytics.openNotifyWhenRestockedLightbox(productSku);
};

const onAlternativeProductStockClick = (productSku, productBatchStocks) => {
    const { ads } = CatalogAdsStore.getState();
    let product = ads.find(product => product.sku === productSku);
    openAlternativeProductStockOnClick(product, productBatchStocks);
};

const onOpenFSFClick = productSku => {
    loadGoogleMapDependencies();
    TYROOLA.mapsInitiated.then(() => {
        LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
        const { ads } = CatalogAdsStore.getState();
        const selectedAdIndex = ads.findIndex(ad => ad.sku === productSku);
        let product = ads[selectedAdIndex];
        product.id = product.sku;
        if (product.stock > 0) {
            if (product.stock < 4) {
                product.qty = product.stock;
            } else if (product.stock >= 4) {
                product.qty = 4;
            }
        }

        const { appliedPostcode } = PostcodeStore.getState();
        const latLng = parseGoogleLatLng(MapStore.getState().latLng);
        if (typeof latLng.lat !== 'undefined'
            && typeof latLng.lng !== 'undefined'
            && null !== appliedPostcode) {
            let stations = FittingStationStore.getState().stations;
            if (stations.length > 0) {
                let currentProducts = ProductsStore.getState();
                if (currentProducts.length > 0 && productSku !== currentProducts[0].id) {
                    StationsActions.clearStationAction();
                    setProductAction([product]);
                    loadStations(appliedPostcode);
                }
            } else {
                setProductAction([product]);
                loadStations(appliedPostcode);
            }
            LightboxActions.openAction();
            LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
        } else {
            setProductAction([product]);
        }

        openCarFittingStationFinder();
    });
};

const onProductClick = () => {
    const { ads } = CatalogAdsStore.getState();
    ProductTileGoogleAnalytics.clickOnAdProduct(ads[0]);
};
